<template>
  <van-overlay :show="show" z-index="2000" :lock-scroll="true" @click="handleClose">
    <div class="assistance-popup">
      <div class="assistance-dialog" @click.stop>
        <div
          class="assistance-dialog__header"
          :style="{ backgroundImage: `url(${headerBg})` }"
        >
          <img
            class="assistance-dialog__close"
            referrerpolicy="no-referrer"
            src="https://lanhu-oss-2537-2.lanhuapp.com/SketchPng052b1c2b0a4f923695693fea9c35b66bf2cf27ddd530bcb09d7b3cc95593c2fa"
            alt=""
            @click="handleClose"
          />
        </div>
        <span class="assistance-dialog__message">{{ message }}</span>
        <div class="assistance-dialog__btn" @click="handleJoin">
          去参与活动
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerBg() {
      return this.success
        ? 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/sharehelp-bg1.png'
        : 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/sharehelp-bg2.png';
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleJoin() {
      this.$emit('join');
    },
  },
};
</script>

<style lang="scss" scoped>
.assistance-popup {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.assistance-dialog {
  width: 580px;
  padding-bottom: 56px;
  background-color: #fff;
  border-radius: 36px;

  &__header {
    display: flex;
    justify-content: flex-end;
    padding: 36px 36px 220px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 36px 36px 0 0;
  }

  &__close {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  &__message {
    display: block;
    margin-top: 7px;
    padding: 0 40px;
    color: #333;
    font-size: 25px;
    line-height: 36px;
    text-align: center;
  }

  &__btn {
    width: 364px;
    margin: 80px auto 0;
    padding: 22px 0;
    color: #fff;
      font-weight: 500;
    font-size: 25px;
      font-size: 24px;
    text-align: center;
    background-color: #ff7f41;
    border-radius: 50px;
    cursor: pointer;
  }
}
</style>
